// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

/**
 *
 * @param obj : object from which properties array is to be made
 * @param mapper : a mapper function that is applied on the properties of the obj values
 */
export function mapObjectToArray(obj: any, mapper?: (item: any) => any): any[] {
    return Object.keys(obj).map(key => (mapper ? mapper(obj[key]) : obj[key]));
}
